import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetFooterAdrienCachotParams } from "../interface";
import usePageLang from "@src/hooks/usePageLang";
import { AvailableLanguage } from "design-system/src/Interface/logoLang";
import FooterAdrienCachot from "design-system/src/Components/WidgetPart/LandingFooter/FooterAdrienCachot/FooterAdrienCachot";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import useSushiShopImage from "@src/lib/render-image/hooks/useSushiShopImage";
import { ImageFormat } from "design-system/src/Components/Image/interface/ImageData";

const LandingFooterAdrienCachot: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetFooterAdrienCachotParams>((props) => {
    const { p } = props;
    const { app } = useBackboneContext();
    const lang = usePageLang();
    const { generateImageUrl } = useSushiShopImage();
    const backgroundMediaDesktop = p("background_media_desktop");
    const backgroundMediaMobile = p("background_media_mobile");

    const backgroundImageDesktop = backgroundMediaDesktop
      ? generateImageUrl({
          id: backgroundMediaDesktop,
          width: "auto",
          height: "auto",
          quality: 100,
          format: ImageFormat.WEBP,
        })
      : undefined;
    const backgroundImageMobile = backgroundMediaMobile
      ? generateImageUrl({
          id: backgroundMediaMobile,
          width: "auto",
          height: "auto",
          quality: 100,
          format: ImageFormat.WEBP,
        })
      : undefined;

    return (
      <>
        {/* fix bottom white border */}
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .widget-instance[data-template="footer-adrien-cachot"] {
                box-shadow: 0px 4px 0px 0px #000;
              }
            `,
          }}
        />
        <FooterAdrienCachot
          lang={lang as AvailableLanguage}
          title={p("title")}
          linkText={p("link_text")}
          onClick={() => app.go("listing")}
          logoLink={"/"}
          socialNetworkLabel={p("social_text")}
          socialLinks={{
            facebook: p("facebook_link"),
            instagram: p("instagram_link"),
            pinterest: p("pinterest_link"),
            tiktok: p("tiktok_link"),
          }}
          backgroundImage={{
            desktop: backgroundImageDesktop || backgroundImageMobile,
            mobile: backgroundImageMobile || backgroundImageDesktop,
          }}
          footerText={p("footer_text")}
        />
      </>
    );
  });

export default LandingFooterAdrienCachot;
